"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = polyfillTimezones;

function polyfillTimezones() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

  // Polyfill zones if necessary
  try {
    Intl.DateTimeFormat('en-US', {
      timeZone: 'Etc/UTC'
    }); // eslint-disable-line new-cap

    return callback();
  } catch (e) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.onload = callback;
    script.src = 'https://unpkg.com/date-time-format-timezone@1.0.21/build/browserified/date-time-format-timezone-all-zones-no-locale-min.js'; // eslint-disable-line max-len

    document.head.appendChild(script);
  }
}